import React from 'react';
import type { CaseEntryTotals } from '../../../utils/caseEntries';
import type { EstimateTotals } from '../../../utils/caseEstimate';
import { diffTone, formatHours, signedHours, signedKr } from '../../../utils/caseEstimate';
import { formatKr } from '../../../utils/quote';
interface EstimateComparisonProps {
  estimate: EstimateTotals;
  actual: CaseEntryTotals;
}

/** Kort overblik: holder sagen sig tæt på tilbuddet? */
export function EstimateComparison({
  estimate,
  actual
}: EstimateComparisonProps) {
  const rows = [{
    label: 'Timer',
    estimated: formatHours(estimate.hoursCount),
    registered: formatHours(actual.hoursCount),
    diff: actual.hoursCount - estimate.hoursCount,
    diffText: signedHours(actual.hoursCount - estimate.hoursCount)
  }, {
    label: 'Materialer',
    estimated: formatKr(estimate.materials),
    registered: formatKr(actual.materials),
    diff: actual.materials - estimate.materials,
    diffText: signedKr(actual.materials - estimate.materials)
  }, ...(estimate.other > 0 || actual.travelService + actual.other > 0 ? [{
    label: 'Øvrigt',
    estimated: formatKr(estimate.other),
    registered: formatKr(actual.travelService + actual.other),
    diff: actual.travelService + actual.other - estimate.other,
    diffText: signedKr(actual.travelService + actual.other - estimate.other)
  }] : [])];
  return <div className="grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-218" data-mp="2x0fczvr2pe7l">
      {rows.map(row => <div key={row.label} className="border-l-2 border-accent/60 pl-4" data-id="element-219" data-mp="31rf8qxoghq8i">
          <p className="text-sm font-semibold text-ink" data-id="element-220" data-mp="31s72s42enfwo">{row.label}</p>
          <dl className="mt-1 grid grid-cols-3 gap-2 text-sm" data-id="element-221" data-mp="36pgtro5fzzmm">
            <div data-id="element-222" data-mp="3bpv2l8evbdlp">
              <dt className="text-xs text-ink-muted" data-id="element-223" data-mp="3bqe97sz2ifkf">Estimeret</dt>
              <dd className="whitespace-nowrap text-ink" data-id="element-224" data-mp="3fr6igm7xwkgp">{row.estimated}</dd>
            </div>
            <div data-id="element-225" data-mp="3fou0i926ma3n">
              <dt className="text-xs text-ink-muted" data-id="element-226" data-mp="1gm6ppbbw1emz">Registreret</dt>
              <dd className="whitespace-nowrap text-ink" data-id="element-227" data-mp="1gkc743o39ym2">{row.registered}</dd>
            </div>
            <div data-id="element-228" data-mp="1bl8zqckmzgax">
              <dt className="text-xs text-ink-muted" data-id="element-229" data-mp="1peqgxqpuogxs">Forskel</dt>
              <dd className={`whitespace-nowrap font-medium ${diffTone(row.diff)}`} data-id="element-230" data-mp="1pgbfrsj76m1g">{row.diffText}</dd>
            </div>
          </dl>
        </div>)}
    </div>;
}